/**------------- Section Container constants -------------**/

/*  General  */
export const SECTION_CONTAINER_CLASS_NAME =
	"section-container";
